import { React, Component, Container, Config, _ } from 'utils';
import { CreditStore } from 'model';
import './db-control-panel.less'

class DbPanel extends Component {

	static getStores() {
		return [CreditStore];
	}

	static calculateState() {
		return {
			total: CreditStore.getState().total,
		}
	}

	render() {
		const { total } = this.state;

		let msg =_('Isprobaj bazu besplatno');
		if (total > 0) {
            msg =_('Pretraži bazu');
		}

		return (
			<div className="db-panel-status">
				<h4>{_('Baza životopisa')}</h4>
				<div className="row">
					<div className="db-panel-status-left col-sm-6">				
						<p>{_('Pretražite aktivne životopise i pronađi idealnog zaposlenika')}</p>
                        <a className="btn btn-primary" type="button" href={Config.tryUrl}>{msg}</a>
						<a className="btn btn-gray" type="button" href={Config.buyUrl}>{_('Kupi kredite')}</a>
					</div>
					<div className="db-panel-status-right col-sm-6">

						<span>{_('Preostali krediti')}</span>
						<div>
							<h3>{total}</h3>
						</div>

					</div>
				</div>
			</div>
		);
	}
}

const container = Container.create(DbPanel);
export default container;


// WEBPACK FOOTER //
// ./src/modules/app/DbPanel.js